module.exports = __webpack_public_path__ + "media/flags/um-1ba09c7c.svg";